import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import LoadingPage from "../components/LoadingPage";
import toast from "react-hot-toast";

const Callback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get("token");

    if (token) {
      localStorage.setItem("jwtToken", token);
    }
    toast.success("Successfully logged in!", {
      iconTheme: {
        primary: "#333",
        secondary: "#DCB41F",
      },
      style: {
        backgroundColor: "#333",
        color: "#DCB41F",
      },
    })
    navigate("/");
  }, [navigate]);

  return <LoadingPage />;
};

export default Callback;
